<template>
    <div class="subject-special-list">
        <!-- 特殊专题pc -->
        <div class="subject-special-title" v-if='!isPhone'>
            联合指导：中央网信办举报中心、中共四川省委网信办<br>联合出品：中国互联网联合辟谣平台、四川互联网联合辟谣平台、封面新闻<br>支持单位：四川省文物考古研究院、三星堆研究院、三星堆博物馆
        </div>
        <div class="subject-special-banner" v-if="banner.length && !isPhone">
            <div class="kuang"></div>
            <div class="box">
                <div id="banner" class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, i) in banner" :key="i">
                            <div class="img">
                                <img :src="item.imgUrl || require('./../assets/img/default.png')" :onload="imgLoaded" :onerror="errorImg" alt/>
                            </div>
                            <div class="bottom">
                                <span class="icon swiper-toLeft" ></span>
                                <div class="text-inner">{{item.itemTitle}}</div>
                                <span class="icon swiper-toRight"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- sData && sData.desc && -->
        <div class="subject-specia-desc" v-if=" !isPhone">
            <img src="../assets/img/piyao-suject-icon-left.png" class="icon-left"/>
            <span class="title">三星堆·问答</span>
            <div class="content">即日起，为增进对三星堆文化的理解，结合现有的研究成果，由中央网信办举报中心和四川省委网信办指导，在四川省文物考古研究院 、三星堆研究院、三星堆博物馆支持下，中国互联网联合辟谣平台、四川互联网联合辟谣平台、封面新闻联合推出寻路古蜀大型人文报道之——“三星堆问答”大型策划，以文化传播为目的，解读三星堆文化，解读三星堆。</div>
            <img src="../assets/img/piyao-suject-icon-right.png" class="icon-right"/>
        </div>
        <!-- 特殊专题wap -->
        <div class="subject-special-title-wap"  v-if='isPhone'></div>
        <div id="banner" class="subject-special-banner-wap swiper-container" v-if="banner.length && isPhone">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, i) in banner" :key="i">
                    <div class="img">
                        <span v-show="item.flag == 3" class="video-icon"></span>
                        <span class="zhegai"></span>
                        <img :src="item.imgUrl || require('./../assets/img/default.png')" :onload="imgLoaded" :onerror="errorImg" alt/>
                    </div>
                    <div class="bottom">
                        <div class="text-inner">{{item.itemTitle}}</div>
                    </div>
                </div>
            </div>
            <div class="swiper-pagination"></div>
        </div>
        <!-- sData && sData.desc && -->
        <div class="subject-specia-desc-wap" v-if=" isPhone">
            <div class="title">三星堆·问答</div>
            <div class="content">
                <img src="../assets/img/piyao-suject-icon-left-wap.png" class="icon-left"/>
                即日起，为增进对三星堆文化的理解，结合现有的研究成果，由中央网信办举报中心和四川省委网信办指导，在四川省文物考古研究院 、三星堆研究院、三星堆博物馆支持下，中国互联网联合辟谣平台、四川互联网联合辟谣平台、封面新闻联合推出寻路古蜀大型人文报道之——“三星堆问答”大型策划，以文化传播为目的，解读三星堆文化，解读三星堆。 
                <img src="../assets/img/piyao-suject-icon-right-wap.png" class="icon-right"/>
            </div>
        </div>
    </div>
</template>
<script>
import Swiper from 'swiper/js/swiper.min.js';
import 'swiper/css/swiper.css';
// 特殊专题顶部公用组件
export default {
    name: 'SubjectSpecial',
    data() {
        return {
           imgLoaded: `this.style.background = 'none'`, 
           errorImg: 'this.src="'+ require('./../assets/img/default.png') + '"',
           swiper:null
        }
    },
    props: {
        columnId: {
            type: String,
            default: null
        },
        banner: { //数据
            type: Array,
            default: []
        },
        sData: {
            type: Object,
            default: null
        }
    },
    mounted() {
        console.log(this.banner)
        console.log(this.sData)
        //由接口控制，2个以上才返回banner,前端不做控制
        // this.$nextTick(()=> {
        //     this.setSwiper();
        // })

        // setTimeout(()=>{
        //     this.setSwiper();
        // },100)
    },
    beforeUpdate(){
        if(this.banner.length > 0){
            this.$nextTick(()=> {
                this.setSwiper();
            })
        }
        
    },
    // watch:{
    //     banner(val,oldVal){
    //         if(val.length > 0){
    //             setTimeout(()=>{
    //                 this.setSwiper();
    //             },100)
    //         }
            
    //     }
    // },
    methods: {
        setSwiper(){
            let that = this;
            if(this.isPhone){
                this.swiper = new Swiper('#banner', {
                    spaceBetween: 0,
                    loop: true,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false//用户操作swiper之后，是否禁止autoplay
                    },
                    on:{
                        tap: function(e){//在移动端，click会有 200~300 ms延迟，所以请用tap代替click作为点击事件
                            let domClass = e.target.className
                            if (domClass && domClass.indexOf('icon') > -1) {
                                 return
                            }
                            let index = this.realIndex
                            console.log('点击',index)
                            that.toWapDetail(index);
                        },
                    },
                    // 如果需要分页器
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    }
                })
            }else{
                this.swiper = new Swiper('#banner', {
                    spaceBetween: 0,
                    loop: true,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false
                    },
                    on:{
                        click: function(e){
                            let domClass = e.target.className
                            if (domClass && domClass.indexOf('icon') > -1) {
                                 return
                            }
                            let index = this.realIndex
                            console.log('点击',index)
                            that.toWapDetail(index);
                        },
                    },
                    navigation: {
                        nextEl: '.swiper-toRight',
                        prevEl: '.swiper-toLeft',
                    },
                })
            }
        },
        toWapDetail(index) {
            const item = this.banner[index];
            // if(item.flag === 4) return window.open(item.itemExternalUrl)
            // let url = '';
            // if(item.isSubjectEntrance) {
            //     url = `/subject/${this.$Common.Base64.encode(item.subjectId)}`;
            //     if(this.columnId) url += '?columnId=' + this.columnId
            // } else if(item.newsKind == 6) {
            //     url = item.externalUrl;
            // } else {
            //     url = `/news/${this.$Common.Base64.encode(item.itemId)}`;
            // }
            // window.open(this.$router.resolve({
            //     path: url
            // })['href'], '_blank');
            if (item.flag == 2 || item.flag == 5) return
            let url = ''
            // flag  跳转方式  0-新闻 1-专题 2-直播 3-视频 4-外链  5-图集
            switch (item.flag) {
                case 0:
                url = this.$router.resolve({
                    path: `/news/${this.$Common.Base64.encode(item.itemId)}/${this.$Common.Base64.encode(100)}`
                })['href']
                break;
                case 1:
                url = this.$router.resolve({
                    path: `/subject/${this.$Common.Base64.encode(item.itemId)}`
                })['href']
                break;
                case 3:
                url = this.$router.resolve({
                    path: `/news/${this.$Common.Base64.encode(item.itemId)}`
                })['href']
                break;
                case 4:
                url = item.itemExternalUrl
                break;
                default:
                break;
            }
            return window.open(url)
        },
    },
    computed: {
        isPhone() {
            return this.$Common.Attribute.isMb()
        }
    }
}
</script>
<style lang="less" scoped>
    .subject-special-list{
        .subject-special-title{
            text-align: center;
            font-size: 1rem;
            line-height: 1.44rem;
            font-weight: 800;
            color: #32563A;
            padding:13.54rem 0 0.89rem;
        }
        .subject-special-banner{
            position: relative;
            padding-bottom: 1.53rem;
            .kuang{
                position: absolute;
                top: 1.26rem;
                left: 50%;
                transform: translateX(-50%);
                width: 46.32rem;
                height: 20.53rem;
                border: 0.05rem solid #32563A;
                z-index: 0;
            }
            .box{
                position: relative;
                z-index: 1;
                margin: 0 auto;
                width: 42.11rem;
                border: 0.05rem solid #32563A;
                .swiper-container {
                    width: 100%;
                    height: 26.153rem;
                    .swiper-slide {
                        .img {
                            width: 100%;
                            height: 23.703rem;
                        }
                        .bottom{
                            position: relative;
                            padding: 0 4.21rem;
                            height: 2.45rem;
                            box-sizing: border-box;
                            background: #32563A;
                            .text-inner{
                                height: 2.45rem;
                                line-height: 2.45rem;
                                font-size: 1.05rem;
                                color:#FFD457;
                                overflow: hidden;
                                text-overflow:ellipsis;    
                                white-space: nowrap;                      
                            }
                            .icon{
                                position: absolute;
                                top:0.75rem;
                                content: ' ';
                                display: inline-block;
                                height: 0.8rem;
                                width: 0.8rem;
                                border-width: 0 0 0.04rem 0.04rem;
                                border-color: #d9d9d9;
                                border-style: solid;
                                cursor: pointer;
                                &.swiper-toLeft{
                                    left: 1.5rem;
                                    transform: rotate(404deg);
                                }
                                &.swiper-toRight{
                                    right: 1.5rem;
                                    transform: rotate(224deg);
                                }
                            }
                        }
                    }
                }
            }
        }
        .subject-specia-desc{
            position: relative;
            padding: 0 6.47rem 2.32rem;
            text-align: center;
            .title{
                display: inline-block;
                padding: 0 3.6rem;
                height: 3.13rem;
                line-height: 3.13rem;
                font-size: 1.16rem;
                font-weight: 500;
                color: #333333;
                background: url('../assets/img/piyao-suject-title.png') no-repeat;
                background-size: cover;
                margin-bottom: 1.68rem;
            }
            .content{
                font-size: 0.84rem;
                color: #474646;
                min-height: 5rem;
                max-height: 25.53rem;
                overflow: auto;
                line-height: 1.37rem; 
                text-align: left; 
            }
            img{
                position: absolute;
                width: 7.05rem;
                height: 7.05rem;
                &.icon-left{
                    top: 0;
                    left: 1.42rem;
                }
                &.icon-right{
                    bottom: 0.47rem;
                    right: 1.42rem;
                }
            }
        }
        .subject-special-title-wap{
            height: 40.6vw; 
            background: url('../assets/img/piyao-subject-wap-bg1.png') no-repeat top left;
            background-size: 100%;
        }
        .subject-special-banner-wap{
            height: 56.2vw;
            .swiper-wrapper{
                .swiper-slide{
                    position: relative;
                    .img{
                        position: relative;
                        height: 56.2vw;
                        .video-icon {
                            position: absolute;
                            width: 6.667vw;
                            height: 6.667vw;
                            background: url('./../assets/img/video_play.png') center no-repeat;
                            background-size: cover;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                        .zhegai{
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            z-index: 1;
                        }
                    }
                    .bottom{
                        position: absolute;
                        width: 100%;
                        left: 0;
                        bottom: 0;
                        padding: 6.8vw 4vw 4.4vw;
                        box-sizing: border-box;
                        background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%);
                        .text-inner{
                            min-height: 12.8vw;
                            font-size: 4.53vw;
                            line-height: 6.4vw;
                            color:#fff;
                            overflow: hidden;
                            text-overflow:ellipsis;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                        }
                    }
                }
            }
        }
        .subject-specia-desc-wap{
            padding: 4.4vw 4vw 1.33vw;
            .title{
                text-align: center;
                height: 16vw;
                line-height: 16vw;
                color: #FFD457;
                font-size: 4vw;
                font-weight: 500;
                background: url('../assets/img/piyao-subject-wap-title.png') no-repeat top left;
                background-color: #F9F5EC;
                background-size: 100%;
                border-radius: 1.6vw 1.6vw 0 0;
            }
            .content{
                position: relative;
                padding: 5.33vw 4vw;
                font-size: 3.47vw;
                line-height: 5.33vw;
                color:#333333;
                background: #F9F5EC;
                border-radius: 0 0 1.6vw 1.6vw;
                min-height: 20vw;
                img{
                    position: absolute;
                    width: 14.93vw;
                    height: 11.87vw;
                    &.icon-left{
                        top: 2.67vw;
                        left: 2.67vw;
                    }
                    &.icon-right{
                        bottom: 2.67vw;
                        right: 2.67vw;
                    }
                }
            }
        }
    }
</style>